import type { ComponentEditorMetaDataDefinition } from '../types';

const metaData: ComponentEditorMetaDataDefinition = {
  skipInQuickEditPanel: true,
};

export default metaData;
